import { ProjectCard } from './ProjectCard';
import { VideoEmbed } from './VideoEmbed';

export default function Work() {
  return (
    <section aria-label="Work">
      <ProjectCard
        number="1"
        title="Self-Evaluating Multilingual Video Intelligence Pipeline"
        // meta="Video Volunteers NGO • 4 months • 2024"
        description={
          <>
            <img
              src="/video_pipeline_flowchart.png"
              alt="Flowchart for multilingual video pipeline"
              className="mb-4 w-full border border-gray-300"
            />
            <p>
            I worked on a 5-month project with a US-based media-tech organization that manages a large archive of citizen video interviews in multiple Indian languages, and they needed a way to turn thousands of these videos into usable text for research and archiving. At first glance, it seemed like a straightforward ASR + translation problem, but it wasn’t. 
            <br></br>The audio was often messy, dialect-heavy, and had multiple speakers, so basic transcription and translation pipelines produced outputs that looked fine on the surface but were actually unreliable. Morover, those were incapable of handling longer videos. 
            <br></br>Instead of just processing the data, we built a multi-step system that also refines and judges its own outputs, evaluating transcripts and translations across multiple dimensions, identifying where things went wrong, and deciding whether to accept, fix, or re-run parts of the pipeline. Over time, this evolved into a feedback-driven system that doesn’t just generate text, but actively reasons about its quality, making it possible to scale while still maintaining trust in the data and minimize hallucinations.
            </p>
          </>
        }
      />

      
      <ProjectCard
        number="2"
        title="AI Launchpad in the Himalayas"
        description={
          <>
            {/* <img
              src="/ai_launchpad_in_the_himalayas.png"
              alt="AI Launchpad in the Himalayas"
              className="mb-4 w-full border border-gray-300"
            /> */}

            <VideoEmbed
              src="/video_dharamshala_2.mp4"
              title="AI Launchpad in the Himalayas — project clip"
            />
            
            <p>
            I got a pretty rare opportunity to spend a few months in the foothills of the Himalayas at the AltSpace AI Launchpad in Dharamshala. What started as raw ideation and deep market exploration quickly turned into building and selling real products. Every week meant intense demo Fridays, shipping updates, talking traction, and figuring things out in real time. We had sessions ranging from Claude code optimizations and context engineering to GTM strategy and pitching to top VCs on the final demo day. Learned a lot from the people around me, built fast, and came back with both real-world experience and some incredible memories.
            </p>

          </>
        }
      />

      
      {/* <ProjectCard
        number="3"
        title="CA Client-Agent"
        // meta="One-day build • 2024"
        description={
          <>
            <p>
              Automated deadline tracking system for CA boutique firms. Prevents penalties from missed compliance deadlines. Another feature includes generating solutions and recommendations based on past cases and regulations.
            </p>
            <p className="mt-4">
              Talked to CA firm owner about pain points, which are too common in the industry, and built the requirements. 
            </p>
          </>
        }
      /> */}
    </section>
  );
}
